
// export const url = "https://d32caa46-e738-4b34-9978-f9ba4f035d40.mock.pstmn.io/v1/videos";
// export const url = "https://d32caa46-e738-4b34-9978-f9ba4f035d40.mock.pstmn.io";
export const url = "https://64197c8f-f69d-4b4a-893e-b703a638777c.mock.pstmn.io";

export const workSpace = "http://13.233.210.245:8081/";